
import React, {useState, useEffect} from 'react';
import './App.css';
import SearchIcon from '@material-ui/icons/Search';
import Navbar from './components/Navbar';
import {BrowserRouter, Route} from 'react-router-dom';

const App =()=> {
  const [searchValue, setSearchValue] = useState("kolkata");
  const [tempInfo, setTempInfo] = useState({});
  const getWeatherInfo = async () => { 
        try {
          let url= `https://api.openweathermap.org/data/2.5/weather?q=${searchValue}&units=metric&appid=19bbd6707dbef10fff8c53e6a6d197b3`;
          const res= await fetch(url);
          const data = await res.json();
          const { temp, feels_like, temp_min, temp_max, pressure, humidity } = data.main;
          const {main:weatherday} = data.weather[0];
          const { name } = data;
          const {speed} = data.wind;
          const {country, sunrise, sunset} = data.sys;
          const visibility = data.visibility;
      


          const myNewWeatherInfo = {
            temp,
            feels_like,
            temp_min,
            temp_max,
            pressure,
            humidity,
            weatherday,
            name,
            speed,
            sunrise,
            sunset,
            country,
            visibility,
          };

            setTempInfo(myNewWeatherInfo);

          




        } catch (error) {
          console.log(error);
        }
  };
  useEffect(() => { 
    getWeatherInfo();
  }, []);
  return(
   <>
   <div className="header">

<div className="search-container">
  <input type="text" 
  className="searchbar" 
  placeholder="Search by your city" 
  value={searchValue}
  onChange={(e)=> setSearchValue(e.target.value)}
  />
  <button type="submit" 
  onClick={getWeatherInfo}>< SearchIcon/></button>
</div>
</div>
   <Navbar tempInfo={tempInfo}/>
  
   </>


  )
}

export default App;
